/* ==========================================================================
   MasonryCarousel > Client > Config
   ========================================================================== */

/* Modules */
/* Exports */
module.exports = ({ bullets = false } = {}) => ({
    component: 'MasonryCarousel',
    type: {
        card: 'masonry-card'
    },
    carousel: {
        init: true,
        hasPagination: !!bullets,
        hasNavigation: true,
        hasBreakpoints: true,
        swiper: {
            init: true,
            // Default parameters
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 12,
            containerModifierClass: 'masonry-carousel__carousel--',
            slideClass: 'masonry-carousel__carousel-slide',
            slideActiveClass: 'masonry-carousel__carousel-slide--active',
            slideVisibleClass: 'masonry-carousel__carousel-slide--visible',
            slideNextClass: 'masonry-carousel__carousel-slide--next',
            slidePrevClass: 'masonry-carousel__carousel-slide--prev',
            wrapperClass: 'masonry-carousel__carousel-wrapper',

            // Responsive breakpoints
            breakpoints: {
                // when window width is <= 480px
                480: {
                    slidesPerView: 1,
                    slidesPerGroup: 1
                },
                // when window width is <= 720px
                991: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                // when window width is <= 1200px
                1200: {
                    slidesPerView: 3,
                    slidesPerGroup: 3
                },
                // when window width is <= 1600px
                1600: {
                    slidesPerView: 4,
                    slidesPerGroup: 4
                }
            },

            // Navigation
            navigation: {
                nextEl: '.masonry-carousel__carousel-button--next',
                prevEl: '.masonry-carousel__carousel-button--prev',
                hiddenClass: 'masonry-carousel__carousel-button--hidden',
                disabledClass: 'masonry-carousel__carousel-button--disabled'
            },

            // Pagination
            pagination: {
                el: '.carousel__pagination',
                modifierClass: 'carousel__pagination--',
                currentClass: 'carousel__pagination--current',
                totalClass: 'carousel__pagination--total',
                hiddenClass: 'carousel__pagination--hidden',
                bulletClass: 'carousel__bullet',
                bulletActiveClass: 'carousel__bullet--active',
                clickable: true,
                clickableClass: 'carousel__pagination--clickable'
            }
        }
    }
});
